import PropTypes from 'prop-types';
import { FormSection } from 'redux-form';
import { m as motion } from 'framer-motion';
import { css } from '@eti/styles';
import ManulifeTravelerContainer from '../containers/ManulifeTravelerContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const motionVariants = {
  hide: {
    opacity: 0,
    height: 0
  },
  show: {
    opacity: 1,
    height: 'auto'
  }
};
const manulifeTravelersWrapperStyles = isActive => css`
  visibility: ${isActive ? 'visible' : 'hidden'};
`;
const listStyles = css`
  margin-top: 15px;
`;
const ManulifeTravelers = _ref => {
  let {
    isActive,
    dateFormat,
    form,
    onFetchPrice,
    productName,
    travelers = []
  } = _ref;
  return /*#__PURE__*/_jsx(motion.div, {
    animate: isActive ? 'show' : 'hide',
    className: manulifeTravelersWrapperStyles(isActive),
    "data-testid": `${productName}-travelers`,
    transition: {
      type: 'tween',
      duration: 0.3
    },
    variants: motionVariants,
    children: /*#__PURE__*/_jsx(FormSection, {
      name: `${productName}.travelers`,
      children: /*#__PURE__*/_jsx("ul", {
        className: listStyles,
        children: travelers.map(_ref2 => {
          let {
            ageType,
            id,
            dateOfBirthReadOnly,
            name
          } = _ref2;
          return /*#__PURE__*/_jsx(ManulifeTravelerContainer, {
            ageType: ageType,
            dateFormat: dateFormat,
            form: form,
            id: id,
            isDateOfBirthReadOnly: dateOfBirthReadOnly,
            name: name,
            onFetchPrice: onFetchPrice,
            productName: productName
          }, `${productName}-traveler-${id}`);
        })
      })
    })
  });
};
ManulifeTravelers.propTypes = {
  dateFormat: PropTypes.string,
  form: PropTypes.string,
  isActive: PropTypes.bool,
  onFetchPrice: PropTypes.func.isRequired,
  productName: PropTypes.string,
  travelers: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any))
};
export default ManulifeTravelers;
//# sourceMappingURL=ManulifeTravelers.js.map